import styled from 'styled-components';

export const Style = styled.div`
  /* 공통 */
  h1 {
    font-size: 24px;
  }
  h2 {
    font-size: 20px;
    color: #333333;
    font-weight: 600;
  }
  h3 {
    font-size: 14px;
    font-weight: 400;
  }
  h4 {
    font-size: 10px;
    font-weight: 400;
    line-height: 16px;
  }
  .rowCenter {
    display: flex;
    align-items: center;

    img {
      margin-right: 4px;
    }
  }
  .rowCenter.start {
    align-items: flex-start;
    h3 {
      padding: 0;
      margin: 0;
    }
    img {
      margin-top: 4px;
    }
  }
  .powerStatusWrap {
    display: flex;
    align-items: center;
    gap: 2px;
    margin-bottom: 4px;
    .powerItem {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #4dd2ae;
      border-radius: 3px;
      padding: 4px 2px;
      gap: 2px;
      p {
        font-size: 12px;
        line-height: 18px;
        margin: 0;
        color: #fff;
        font-weight: 600;
      }
      img {
        height: 12px;
      }
    }
    .powerItem.error {
      background: #ff6060;
    }
    .powerItem.off {
      background: #a7a7a7;
    }
  }

  .powerBox {
    display: flex;
    align-items: center;
    padding: 2px 4px;
    border-radius: 4px;
    gap: 4px;
  }
  .powerBox.off h4 {
    color: #a7a7a7;
  }
  .powerBox.error h4 {
    color: #ff6060;
  }
  .powerBox.on h4 {
    color: #4dd2ae;
  }

  /* wrap */
  .wrap {
    width: 100%;
    min-height: 100vh;
    padding: 30px 3vw;
    background: #fafafa;

    h1 {
      margin-bottom: 6px;
    }
  }

  /* select */
  .selectWrap {
    width: 55%;
  }

  /* areaWrap */
  .areaWrap {
    margin-top: 16px;

    h2 {
      margin-bottom: 6px;
      font-size: 18px;
    }
  }

  /* roomWrap */
  .roomWrap {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5%;
    height: 100%;
  }
  .roomContent {
    width: 10%;
    height: 100%;
    margin-bottom: 6px;
    padding: 6px 8px;
    border: 1px solid #cecece;
    background: #fefefe;
    border-radius: 4px;
    h2 {
      margin-bottom: 4px;
      font-size: 14px;
      text-align: center;
    }
  }
  .roomTitle {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;

    h2,
    p {
      margin: 0;
    }
    .roomTypeStatus {
      padding: 4px 12px 2px 12px;
      font-size: 12px;
      background: #eee;
      color: #777;
      border-radius: 4px;
    }
    .roomTypeStatus.checkin {
      background: #4dd2ae;
      color: #fff;
    }
  }

  /* devicesWrap */
  .renderWrap {
    margin-top: 10px;
    border-top: 1px solid #eee;
  }
  .devicesWrap {
    padding: 4px;
    margin-top: 6px;
  }
  .devicesWrap.fail {
    background: #eee;
    border-radius: 5px;

    p {
      font-size: 14px;
      font-weight: 500;
      text-align: center;
      color: #cecece;
    }
  }
  .devicesWrap.error {
    border-radius: 10px;
    border: 2px solid #ff6060;
  }
  .devicesWrap.longTime {
    border-radius: 10px;
    border: 2px solid orange;
  }
  .devicesContent {
    margin-top: 4px;
    gap: 4px;
  }
  .bottomBoxWrap {
    margin-top: 12px;
  }
  /* devicesWrap-topWrap */
  .topWrap {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .activeStatus {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;
    margin-top: 4px;

    .circle {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #4dd2ae;
    }
    p {
      padding: 0;
      margin: 0;
      font-size: 12px;
      color: #4dd2ae;
      font-weight: 600;
    }
  }
  .activeStatus.off {
    .circle {
      background: #ff6060;
    }
    p {
      color: #ff6060;
    }
  }
  .activeStatus.off {
    .success {
      color: #a7a7a7;
    }
  }

  .activeStatus.fail {
    .circle {
      background: #a7a7a7;
    }
    p {
      font-size: 14px;
      color: #a7a7a7;
    }
  }

  .logViewButton {
    width: 100%;
    margin-top: 2px;
    padding: 6px 0;
    background: #f6f6f6;
    color: #3f3f3f;
    border: none;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    border: 1px solid #eee;
  }
  .logViewButton.marginTop {
    margin-top: 16px;
  }
  .logViewButton.total {
    width: 55%;
    background: #3f3f3f;
    padding: 10px 0;
    font-size: 16px;
    color: #fff;
  }

  .errorDeviceWrap {
    margin: 20px 0 60px 0;

    .header {
      padding: 12px 30px;
      background: #ff6060;
      color: #fff;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      font-size: 16px;
      font-weight: 500;
      text-align: center;
    }
  }
  .errorDeviceListWrap {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 12px 10px;
    background: #ffebeb;
    border: 1px solid #ff6060;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  .notice {
    width: 100%;
    margin-top: 20px;
    h3 {
      color: #ff6060;
    }
  }
  .errorDeviceList {
    width: 10%;
    margin-bottom: 4px;
    background: #fff;
    border-radius: 4px;
    border: 1px solid #cecece;
    padding: 4px;

    h3 {
      padding: 2px 0;
      font-size: 12px;
      color: #ff6060;
      line-height: 20px;
      font-weight: 500;
    }
    .errorRoomName {
      color: #333;
      font-weight: 600;
      text-align: center;
    }
    h4 {
      color: #ff6060;
    }
    .errorList {
      border-top: 1px solid #eeeeee;
      padding: 8px 6px;
    }
  }
  .borderLine {
    background: #eaeaea;
    height: 10px;
    margin: 40px 0;
  }

  .row {
    gap: 8px;
  }
  .rotateButton {
    background: #ddd;
    display: flex;
    align-items: center;
    padding: 8px 12px;
    border: none;
    gap: 7px;
    border-radius: 4px;
    border: 1px solid #333;

    p {
      margin: 0;
      color: #333;
      font-weight: 600;
      white-space: nowrap;
    }
    img {
      width: 20px;
      height: 20px;
    }
  }

  @media (max-width: 1300px) {
    .selectWrap {
      width: 100%;
    }
    .roomContent {
      width: 200px;
    }
    .logViewButton.total {
      width: 100%;
    }
    .errorDeviceList {
      width: auto;
      min-width: 145px;
    }
  }
`;
